import { GATEWAY_API_URL, CORE_SERVICE_KEY } from '../../boot/config';

const createUrl = (path: string): string =>
  `${GATEWAY_API_URL}/${CORE_SERVICE_KEY}/${path}`;
export const createCoreServiceUrl = (path: string): string => createUrl(path);
